import { render, staticRenderFns } from "./worker-or-user.vue?vue&type=template&id=37a5a3ec&"
import script from "./worker-or-user.vue?vue&type=script&lang=js&"
export * from "./worker-or-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a5a3ec')) {
      api.createRecord('37a5a3ec', component.options)
    } else {
      api.reload('37a5a3ec', component.options)
    }
    module.hot.accept("./worker-or-user.vue?vue&type=template&id=37a5a3ec&", function () {
      api.rerender('37a5a3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/worker-or-user.vue"
export default component.exports